$(document).ready(function () {
    // Breadcrumb single-item class logic
    $(".breadcrumb ul").each(function () {
      var $ul = $(this);
      var $breadcrumb = $ul.closest('.breadcrumb');
      if ($ul.find('li').length === 1) {
        $breadcrumb.addClass('single-item');
      } else {
        $breadcrumb.removeClass('single-item');
      }
    });
  // Accordion toggle
  $(".FAQ .wrapper .title").on("click", function () {
    var $content = $(this).next(".text-wrap");

    // Close all other contents
    $(".FAQ .text-wrap").not($content).slideUp().removeClass("open");
    $(".FAQ .wrapper .title").not(this).removeClass("active");

    // Toggle current
    if ($content.is(":visible")) {
      $content.slideUp().removeClass("open");
      $(this).removeClass("active");
    } else {
      $content.slideDown().addClass("open");
      $(this).addClass("active");
    }
  });

  // Open first accordion by default for each .FAQ section
  $(".FAQ").each(function () {
    var $section = $(this);
    var $firstTitle = $section.find(".wrapper .title").first();
    if ($firstTitle.length) {
      var $firstContent = $firstTitle.next(".text-wrap");
      $firstTitle.addClass("active");
      $firstContent.addClass("open").show(); // use .show() instead of slideDown for instant open
    }
  });
});